import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { configUrl } from "../constants/Config";
import {
  PriorAuthReferralSourceDispatchTypes,
  PayerListDispatchTypes,
  DiseaseTypeDispatchTypes,
  IcdCodeTypeDispatchTypes,
} from "../models/DispatchTypes/Master";
import {
  PriorAuthReferralSourceActionDispatchTypes,
  PayerActionDispatchTypes,
  DiseaseTypeActionDispatchTypes,
  IcdCodeTypeActionDispatchTypes,
} from "../constants/Master";
import {
  GetReferralSourceMaster,
  GetPayerPlan,
  diseaseTypeRespValues,
  IcdCodeTypeData,
} from "../services/Master";

export const getPriorAuthReferralSourceMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PriorAuthReferralSourceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_INVOKE,
    });
    const response = await GetReferralSourceMaster(configUrl);

    dispatch({
      response,
      type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS,
    });
  };
};

export const getMasterEligibilityPayer: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PayerListDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PayerActionDispatchTypes.PAYER_INVOKE,
    });

    const response = await GetPayerPlan(configUrl);

    dispatch({
      response,
      type: PayerActionDispatchTypes.PAYER_SUCCESS,
    });
  };
};

export const getDiseaseTypeCall: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DiseaseTypeDispatchTypes
  >
> = (diseaseIdentifier: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_INVOKE,
    });

    const response = await diseaseTypeRespValues(configUrl, diseaseIdentifier);
    if (response) {
      dispatch({
        response: response,
        type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_SUCCESS,
      });
    } else {
      dispatch({
        reponse: [],
        type: DiseaseTypeActionDispatchTypes.DISEASE_TYPE_SUCCESS,
      });
    }
  };
};

export const getIcdCodeTypeData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    IcdCodeTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_INVOKE,
    });

    const response = await IcdCodeTypeData(configUrl);
    dispatch({
      response: response,
      type: IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_SUCCESS,
    });
  };
};
